/*
|==========================================================================
| WordPress + Foundation
|==========================================================================
| 
| These functions make sure WordPress and Foundation play nice together,
| and this is also where we declare functions defined in this folder.
|
|==========================================================================
|
*/

window.onload = function () {

  // Enable AOS for use out of the box
  AOS.init({
    disable: 'mobile',
    offset: 200,
  });

};

jQuery(document).ready(function () {

  /* Shim to support classList method on SVG elements in IE11 */
  if (!("classList" in document.createElementNS("http://www.w3.org/2000/svg", "g"))) {
    var descr = Object.getOwnPropertyDescriptor(HTMLElement.prototype, 'classList');
    Object.defineProperty(SVGElement.prototype, 'classList', descr);
  }

  var elements = document.querySelectorAll('.scroll-about-section');
  Stickyfill.add(elements);

  // Evolving function for WCAG guidelines
  v8_wcag();

  detectBrowserAndDevice();

  // Detect Internet Explorer
  // detect_IE();

  // Detect Safari
  // detect_safari();

  // Detect Native Android Browser
  // detect_native_android_browser();

  // Apple Device Detect
  // apple_device_detect();

  // baguetteBox.run('.executive-management-team-gallery');

  // News Alert
  jQuery(".btn-news-alert").click(function () {
    jQuery('.btn-news-alert').toggleClass('open-alert');
    jQuery('.news-alert-container').toggleClass('open-alert');
  });

  setTimeout(function(){

    jQuery(".blueprint-home-slider .btn-news-alert").click();

    // setTimeout(function(){

      // jQuery(".blueprint-home-slider .btn-news-alert").click();

    // },10000);

  },2500);

  baguetteBox.run('.executive-management-team-gallery', {
    captions: function (element) {
      return this.getElementsByTagName('p')[0].innerHTML;
      // return 'yes';
    }
  });

  // var is_colliding = function( $div1, $div2 ) {

  //   var d1_offset             = $div1.offset();
  //   var d1_height             = $div1.outerHeight( true );
  //   var d1_width              = $div1.outerWidth( true );
  //   var d1_distance_from_top  = d1_offset.top + d1_height;
  //   var d1_distance_from_left = d1_offset.left + d1_width;

  //   var d2_offset             = $div2.offset();
  //   var d2_height             = $div2.outerHeight( true );
  //   var d2_width              = $div2.outerWidth( true );
  //   var d2_distance_from_top  = d2_offset.top + d2_height;
  //   var d2_distance_from_left = d2_offset.left + d2_width;

  //   var not_colliding = ( d1_distance_from_top < d2_offset.top || d1_offset.top > d2_distance_from_top || d1_distance_from_left < d2_offset.left || d1_offset.left > d2_distance_from_left );

  //   return ! not_colliding;

  // };

  // if (is_colliding('.orbit-slide-container', '.slider-text')) {
  //   console.log('collision');
  // }

  jQuery('.home-slider').slick({
    autoplay: false,
    dots: false,
    // appendDots: '.nav-dots',
    // prevArrow: true,
    // nextArrow: true,
    infinite: true,
    speed: 700,
    fade: true,
    cssEase: 'linear',
    // responsive: [
    // {
    //   breakpoint: 641,
    //   settings: "unslick"
    // }]
  });

  jQuery('.story-slider').slick({
    autoplay: true,
    dots: false,
    // appendDots: '.nav-dots',
    // prevArrow: true,
    // nextArrow: true,
    infinite: true,
    speed: 700,
    fade: true,
    cssEase: 'linear',
    // responsive: [
    // {
    //   breakpoint: 641,
    //   settings: "unslick"
    // }]
  });

  var nextColor = (function () {
    var colors = ['#B5DC79', '#006E96', '#002A3A'];
    var count = -1;
    return function () {
      return colors[++count % colors.length];
    };
  }());

  jQuery('.story-slider').on('beforeChange', function (event, slick, currentSlide) {
    var graphic = document.querySelector('.outer-thin-circles');
    graphic.setAttribute("stroke", nextColor());

  });

  /* Function to detect element existence for clarity */
  function elementExists(element) {

    var elementSection = element;
    var elementdoesExist = document.querySelector(elementSection) !== null;

    if (elementdoesExist) {
      return true;
    } else {
      return false;
    }

  }

  var addBodyClass = function (modal) {
    if (elementExists('.apple-device')) {
      document.querySelector('.apple-device').classList.add('modal-open');
    }
  };
  var removeBodyClass = function (modal) {
    if (elementExists('.apple-device')) {
      document.querySelector('.apple-device').classList.remove('modal-open');
    }
  };

  /* Turn on modals */
  if (elementExists('.modal')) {

    MicroModal.init({
      onShow: addBodyClass,
      onClose: removeBodyClass,
      disableScroll: true,
      awaitCloseAnimation: true
    });

  }

  jQuery(function () {
    jQuery('#keywords').tablesorter();
  });

  jQuery(".pipeline-table").each(function (index) {
    jQuery(this).tablesorter();
  });

  // jQuery(function(){
  //   var pipeline_tables = jQuery('.pipeline-table');

  //     for (var i = 0; i < pipeline_tables.length; i++) {
  //     jQuery('#pipeline-table-1').tablesorter(); 
  //   }
  // });

  // Enable skrollr
  var s = skrollr.init({
    forceHeight: false
  });
  if (s.isMobile()) {
    s.destroy();
  }

  // var skrollr_pages = [
  // '.home'
  // ];

  // // Loop through pages and enable skrollr at the template level

  // for (var i = 0; i < skrollr_pages.length; i++) {
  //   if (jQuery(skrollr_pages[i]).length > 0) {
  //     if ( (window.matchMedia("(min-width: 1025px)").matches) ) {
  //       window.skrollrInstance = skrollr.init({
  //         smoothScrolling: true,
  //         forceHeight: false
  //       });
  //     } else {

  //       //  If Skrollr is NOT undefined, let's do the work.
  //       if ( window.skrollrInstance !== undefined ) {
  //           // Use Skrollr's destroy() method on the instance.
  //           window.skrollrInstance.destroy();
  //           // Now set the variable to be completely undefined.
  //           window.skrollrInstance = undefined;
  //         }

  //       }
  //     // disable skrollr if the window is resized below 768px wide
  //     jQuery(window).on('resize', function () {

  //       var _skrollr = skrollr.get();
  //       var _skrollrinit = skrollr.init();

  //       if (jQuery(window).width() <= 1024) {
  //         _skrollrinit.destroy(); // skrollr.init() returns the singleton created above
  //       } else {
  //         var s = skrollr.init({smoothScrolling: true,forceHeight: false});
  //       }
  //     });
  //   }
  // }

  // Gravity Forms Placeholder Clearing
  // gravity_forms_placeholders();

  // Inline SVG replacement
  // inline_svg_replacement();

  // Isotope Masonry
  // isotope_masonry();

  // TablePress Cleanup
  // tablepress();

  // Event Target Testing
  jQuery(document).click(function (event) {

  });

  // Window scroll detection
  jQuery(window).bind("scroll", function (event) {

  });

  // Menu functions
  wp_menu();

  // Menu mobile add class when is it open
  wp_menu_mobile();

  // Remove empty P tags created by WP inside of Accordion and Orbit
  jQuery('.accordion p:empty, .orbit p:empty').remove();

  // Makes sure last grid item floats left
  jQuery('.archive-grid .columns').last().addClass('end');

  // Adds Flex Video to YouTube and Vimeo Embeds
  jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function () {
    if (jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5) {
      jQuery(this).wrap("<div class='widescreen flex-video'/>");
    } else {
      jQuery(this).wrap("<div class='flex-video'/>");
    }
  });

});
